import qs from 'qs'
import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'

import { ITrainingRef, IGetRequestObject } from '../../interfaces'

type QueryObject = {
  activeOnly?: boolean
}

const getTrainingGroupsRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })
  return {
    method: 'get',
    url: `${config.baseUrl}/TrainingGroups/ddl${queryString}`,
  }
}

const useTrainingGroupsQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingRef[] | undefined
>({
  getRequest: getTrainingGroupsRequest,
  getQueryKey: (params, queryObject) => [
    'training-groups',
    queryObject?.activeOnly,
  ],
})

const useTrainingGroupsQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingRef[] | undefined, Error>,
) => {
  const trainingGroupsQuery = useTrainingGroupsQueryBase(
    undefined,
    queryObject,
    options,
  )
  return { ...trainingGroupsQuery }
}

export default useTrainingGroupsQuery
